import { memo } from 'react'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'

interface DelayNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

function DelayNode(props: DelayNodeProps) {
  return (
    <BaseNode
      {...props}
      icon={<HourglassEmptyIcon fontSize="small" />}
      showTargetHandle={true}
      showSourceHandle={true}
    />
  )
}

export default memo(DelayNode)
